<div class="header row align-items-center">
  <div class="col">
    <h3 class="m-y-0">{{'TEXT.CUSTOMER-INFORMATION'|translate}}</h3>
  </div>
</div>

<div class="type-parent" *ngIf="!selectedCustomerType">
  <h5>เลือกประเภทของลูกค้า</h5>
  <div class="row text-center">
    <div class="col-md-6" *ngFor="let type of customerTypes">
      <div class="type-option"
           (click)="selectCustomerType(type)">
        <img [src]="'../../../../assets/images/customer/' + type.type + '.png'" class="mr-4">
        {{ type.name }}
        <br>
        {{ type.nameEN }}
      </div>
    </div>
  </div>
</div>

<div *ngIf="selectedCustomerType">
  <div class="box-filter position-relative z-2">
    <app-filter-header [loading]="loading" (search)="search()" (clear)="clearSearch()"></app-filter-header>

    <div class="row">
      <div class="col h-50">
        <ng-select class="custom" id="buyerName" [items]="buyerNameList"
                   placeholder="{{'NORMAL.CUS-NAME'|translate}}" [(ngModel)]="searchName"
                   [ngClass]="{'selected': searchName || searchingName}"
                   (focus)="searchingName = true" (blur)="searchingName = false">
        </ng-select>
        <label class="select-label" *ngIf="searchName || searchingName"
               for="buyerName">{{'NORMAL.CUS-NAME'|translate}}</label>
      </div>

      <div class="col h-50">
        <ng-select class="custom" id="buyerTaxID" [items]="buyerTaxIDList"
                   placeholder="{{'TABLE.TAX-ID'|translate}}" [(ngModel)]="searchTaxID"
                   [ngClass]="{'selected': searchTaxID || searchingTaxID}"
                   (focus)="searchingTaxID = true" (blur)="searchingTaxID = false">
        </ng-select>
        <label class="select-label" *ngIf="searchTaxID || searchingTaxID"
               for="buyerTaxID">{{'TABLE.TAX-ID'|translate}}</label>
      </div>
    </div>

    <div class="row m-t-10">
      <div class="col h-50">
        <ng-select class="custom" id="buyerBranchCode" [items]="buyerBranchCodeList"
                   placeholder="{{'NORMAL.BRANCH-NAME-CODE'|translate}}" [(ngModel)]="searchBranchCode"
                   [ngClass]="{'selected': searchBranchCode || searchingBranchCode}"
                   (focus)="searchingBranchCode = true"
                   (blur)="searchingBranchCode = false">
        </ng-select>
        <label class="select-label" *ngIf="searchBranchCode || searchingBranchCode"
               for="buyerBranchCode">{{'NORMAL.BRANCH-NAME-CODE'|translate}}</label>
      </div>
      <div class="col h-50">
      </div>
    </div>
  </div>

  <div class="box-parent position-relative z-1">
    <app-custom-pagination
      [(currentPage)]="currentPage"
      [(itemsPerPage)]="itemsPerPage"
      [totalItems]="totalItems"
      (pageChange)="pageChanged()"
      (optionChange)="optionChanged()"
      *ngIf="loading === false && totalItems !== 0"
    >
    </app-custom-pagination>

    <div class="row m-t-20" *ngIf="totalItems === 0 && loading === false">
      <div class="col-12 text-center">
        <h5>{{'COMMON.DATA-NOT-FOUND' | translate}}</h5>
      </div>
    </div>

    <div class="scrollable m-t-30">
      <table class="table text-center" *ngIf="totalItems!== 0 && !loading">
        <thead>
        <tr>
          <th scope="col">{{'NORMAL.QUE'| translate}}</th>
          <th scope="col">{{'NORMAL.CUSTOMER-NAME'| translate}}</th>
          <th scope="col">{{'NORMAL.BRANCH-NAME-CODE'|translate}}</th>
          <!--<th scope="col">ที่อยู่</th>-->
          <!--<th scope="col">รหัสไปรษณีย์</th>-->
          <!--<th scope="col">Country Code</th>-->
          <th scope="col">{{'TABLE.TAX-ID'| translate}}</th>
          <!--<th scope="col">เบอร์โทรศัพท์</th>-->
          <!--<th scope="col">E-mail</th>-->
          <th scope="col"></th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let data of list; let index = index">
          <!--<td>{{((currentPage - 1) * itemsPerPage) + index + 1}}</td>-->
          <td>{{index + 1 + ((currentPage - 1) * itemsPerPage)}}</td>
          <td>{{ data.name }}</td>
          <td>{{ data.branch_code }}</td>
          <!--<td>{{ data.address }}</td>-->
          <!--<td>{{ data.post_code }}</td>-->
          <!--<td>{{ data.country_code }}</td>-->
          <td>{{ data.tax_id }}</td>
          <!--<td>{{ data.phone_number }}</td>-->
          <!--<td>{{ data.email }}</td>-->

          <td>
            <i class="fa fa-1x fa-edit text-warning pointer m-r-5" (click)="openModal(index)"></i>
            <i class="far fa-1x fa-file text-primary pointer" (click)="issue(index)"></i>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <div class="row m-t-20" *ngIf="loading">
      <div class="col-12 text-center">
        <i class="fa fa-spinner fa-2x fa-spin m-r-5"></i>
      </div>
    </div>
  </div>
</div>

<app-customer-detail #detailModal></app-customer-detail>



// WEBPACK FOOTER //
// /opt/app/src/app/features/customer/customer-list/customer-list.component.html